export default [
	// 维修接驳列表
	{
		path: 'repair_handover',
		name: 'm_repair_handover',
		meta: {
			templateManage: {
				workType: 4,
				export: 'b_repair_handover_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/repair/handover_list')
	},
	// 维修列表
	{
		path: 'repair_list',
		name: 'm_repair_list',
		meta: {
			templateManage: {
				workType: 15,
				export: 'b_repair_list_export'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/repair/repair_list')
	},
];
